// Auto-generated normalizer for table: RespuestaExamenTextoLibre
export function respuestaExamenTextoLibreNormalize(row) {
  return {
    idExamenRespuestaTextoLibre: row.idExamenRespuestaTextoLibre ?? row.IdExamenRespuestaTextoLibre ?? row['IdExamenRespuestaTextoLibre'] ?? 0,
    idExamenRespuesta: row.idExamenRespuesta ?? row.IdExamenRespuesta ?? row['IdExamenRespuesta'] ?? 0,
    respuesta: row.respuesta ?? row.Respuesta ?? row['Respuesta'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
